import { apiSlice } from '../../../api/apiSlice';
import { COACHING_GOAL_INFO, CREATE_COACHING_GOAL, UPDATE_COACHING_GOAL_PARENT } from '../../../constants';

export const revGenSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getRevGenCoachingGoal: builder.query({
            query: (data: any) => ({
                url: COACHING_GOAL_INFO,
                method: 'GET',
                params: data,
            }),
            providesTags: ['CoachingGoalInfo'],
        }),
        createRevGenCoachingGoal: builder.mutation({
            query: (data: any) => ({
                url: CREATE_COACHING_GOAL,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['CoachingGoalInfo', 'CoachingGoal'],
        }),
        revgenGoalParentUpdate: builder.mutation({
            query: (data: any) => ({
                url: UPDATE_COACHING_GOAL_PARENT,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['CoachingGoalInfo', 'CoachingGoal'],
        }),
    }),
});

export const {
    useGetRevGenCoachingGoalQuery,
    useCreateRevGenCoachingGoalMutation,
    useRevgenGoalParentUpdateMutation,
} = revGenSlice;
